module.exports = __webpack_public_path__ + "media/6.ef5687c4.mp4";